export class SelfTestPelletizingGri {
  constructor({
          id= null, 
          selfTestCode= ``,
          // sampleTime=``,
          analysisTime = ``,
          residue1 = ``,
          residue2 = ``,
          residue3 = ``,
          granularity1=``,
          granularity2=``,
          granularity3=``,
          granularity4=``,
          concentration=``,
          checkUser=``, 
          status='',
          selfTestId='',
      } = {}) {
      this.id = id;
      this.selfTestCode = selfTestCode;
      // this.sampleTime = sampleTime;
      this.analysisTime = analysisTime;
      this.residue1 = residue1;
      this.residue2 = residue2;
      this.residue3 = residue3;
      this.granularity1=granularity1;
      this.granularity2=granularity2;
      this.granularity3=granularity3;
      this.granularity4=granularity4;
      this.concentration=concentration;
      this.checkUser=checkUser;
      this.status=status;
      this.selfTestId=selfTestId;
      
    }
  }
export function gridFields() {
    return Object.freeze(
        [
         
        
        {
          key: 'selfTestCode',
          label: 'lbl.selfTestPelletizingGri.shiftPlanNum',
          sortable: true,
          form: {
            type: 'input'
          }
        },       
        {
          key: 'analysisTime',
          label: 'lbl.selfTestPelletizingGri.analysisTime',
          sortable: true,
          form: {
            type: 'dateTime'
          }
        },   
        {
            key: 'residue1',
            label: 'lbl.selfTestPelletizingGri.residue1',
            sortable: true,
            form: {
              type: 'input'
            }
          },
        {
          key: 'residue2',
          label: 'lbl.selfTestPelletizingGri.residue2',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
            key: 'residue3',
            label: 'lbl.selfTestPelletizingGri.residue3',
            sortable: true,
            form: {
              type: 'input'
            }
          },
        {
          key: 'granularity1',
          label: 'lbl.selfTestPelletizingGri.granularity1',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'granularity2',
          label: 'lbl.selfTestPelletizingGri.granularity2',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'granularity3',
          label: 'lbl.selfTestPelletizingGri.granularity3',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'granularity4',
          label: 'lbl.selfTestPelletizingGri.granularity4',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
            key: 'concentration',
            label: 'lbl.selfTestPelletizingGri.concentration',
            sortable: true,
            form: {
              type: 'input'
            }
          },
        {
          key: 'checkUser',
          label: 'lbl.selfTestPelletizingGri.checkUser',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'status',
          label: 'lbl.selfTestPelletizingGri.status',
          sortable: true,
          form: {
            type: 'select',
            options: [                
                { value: "N", text:  '未检验' },
                { value: "C", text:  '已检验' },                          
              ]            
          }
        }
    ]);
  }
  export const fields = Object.freeze(Object.keys(new SelfTestPelletizingGri()).map(i => 'entity.' + i));
  export const filterFields = [
    'filter.selfTestCodeFilter',
    'filter.analysisTimeDateFilter',
    'filter.residue1Filter',
    'filter.residue2Filter',
    'filter.residue3Filter',
    'filter.granularity1Filter',
    'filter.granularity2Filter',
    'filter.granularity3Filter',
    'filter.granularity4Filter',
    'filter.concentration',
    'filter.checkUserFilter'
  ];
  export const filter = {
    'selfTestCodeFilter': "",
    'analysisTimeDateFilter': "",
    'residue1Filter': "",
    'residue2Filter': "",
    'residue3Filter':"",
    'granularity1Filter':"",
    'granularity2Filter':"",
    'granularity3Filter':"",
    'granularity4Filter':"",
    'concentration':"",
    'checkUserFilter':"",
  };